import React from 'react';
import { useTranslation } from 'react-i18next';

const LoadingScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-4 border-scaleo-blue border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-gray-500 text-sm">{t('common.loading')}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
